import Navbar from "../NavBar/NavBar";
import "../../StylesPages/events.css";
import Search from "../Search/Search";
import EventsTable from "../EventsTable/EventsTable";
import { AddEvent } from "../AddEventOrOffer/AddEvent";
import { useState, useEffect } from "react";
import { Box, Button, Text } from "@chakra-ui/react";

export const Events = () => {
  const [showAddEvent, setShowAddEvent] = useState(false);
  const [searchedValue, setSearchedValue] = useState("");

  const setSearchedValueFromChild = (v) => {
    setSearchedValue(v);
  };

  const show = () => {
    setShowAddEvent(!showAddEvent);
  };

  const onClick = () => {
    setShowAddEvent(!showAddEvent);
  };

  useEffect(() => {}, [searchedValue]);

  return (
    <Box display="flex" w={"100%"}>
      <Navbar />
      <Box
        mt={["20px", "20px", "0px", "0px"]}
        w={"100%"}
        mb={["120px", "120px", "0px", "0px"]}
      >
        <Text
          ml={["20px", "20px", "40px", "40px"]}
          fontFamily={"Sofia pro"}
          fontSize={"5xl"}
          fontWeight={"bolder"}
        >
          Evenements
        </Text>
        <Box
          p={showAddEvent ? "0px" : ["40px", "40px", "50px", "50px"]}
          mx={
            showAddEvent
              ? ["10px", "10px", "50px", "50px"]
              : ["0px", "0px", "50px", "50px"]
          }
          mt={["20px", "20px", "0px", "0px"]}
          w={["100%", "100%", "calc(100% - 100px) ", "calc(100% - 100px)"]}
          h={["100%", "100%", "calc(100% - 200px) ", "calc(100% - 200px)"]}
          bg={showAddEvent ? "white" : "#d4eeff"}
          borderRadius={"25px"}
        >
          <Box className="events-search" w={"80%"}>
            {/* <Search
              setSearchedValueFromChild={setSearchedValueFromChild}
              annonces={"Evenements"}
            /> */}
            <Button
              className="add-event"
              onClick={onClick}
              bg="#f1404b"
              borderRadius={20}
              color="white"
            >
              {showAddEvent ? "Tableau des évènements" : "Ajouter un évènement"}
            </Button>
          </Box>
          {showAddEvent ? (
            <Box w={"100%"}>
              <AddEvent show={show} title="Ajouter ici" />
            </Box>
          ) : (
            <Box w={"100%"}>
              <EventsTable searchedValue={searchedValue} />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};
